var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgControlCross = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 9 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F64ED",
  d: "M8 1 1 8m7 0L1 1"
})));
export { SvgControlCross as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICAgd2lkdGg9IjkiCiAgICBoZWlnaHQ9IjkiCiAgICB2aWV3Qm94PSIwIDAgOSA5IgogICAgZmlsbD0ibm9uZSIKPgogICAgPHBhdGggZD0iTTggMUwxIDgiIHN0cm9rZT0iIzJGNjRFRCIgLz4KICAgIDxwYXRoIGQ9Ik04IDhMMSAxIiBzdHJva2U9IiMyRjY0RUQiIC8+Cjwvc3ZnPg==";